import { determineCollegeLoanObj } from "../../../objects/AssetsExpenses/determine_college_loan_obj";
import rollForwardDate from "../objects/roll_forward_date_function";

export const createNewLoanTableObject = (adjustedNbrYearsCollege, currentGameDate, startGameDate,
        actualNbrYearsCollege, degreeType, degreeSpecialty, loanTable ) => {
    let newLoanTable = [];
    // 50% chance that employer pays some of the college tuition amount
    const tuitionPaidByEmployer = Math.random().toFixed(0); 
    let pctOfTuition = 0;
    if (tuitionPaidByEmployer === 1){
        pctOfTuition = (Math.floor(Math.random() * 5))/10;
    }
    let loanDesc = degreeType  + "-" + degreeSpecialty;  
    let newLoanObj = determineCollegeLoanObj(adjustedNbrYearsCollege, loanDesc, 
        currentGameDate, startGameDate, pctOfTuition);
    let newTotalCollegeLoanAmt = +newLoanObj.loanTotAmt;
    let saveTotalCollegeLoanAmt = newTotalCollegeLoanAmt;
    if (adjustedNbrYearsCollege === 0){
        newLoanTable = loanTable;
    }else{
        // if college is required then only put college loans in the pending job as these
        // are added to existing loans while player is 'in school'
        newLoanTable = [];
    }
    let collegeLoanTable = [];
    var loanStartDate = currentGameDate;
    let perYearCollegeAmt = saveTotalCollegeLoanAmt / actualNbrYearsCollege;
    for (let i=0; i< actualNbrYearsCollege; i++){
        loanStartDate = rollForwardDate(loanStartDate, 12);
        const finalLoanDesc = loanDesc + "(Year " + (i+1) + ")"
        let nbrYearsRemaining = actualNbrYearsCollege - i;
        let loanYear = 1
        if (nbrYearsRemaining < 1){
            loanYear = nbrYearsRemaining;
        }
        let newLoanObj = determineCollegeLoanObj(loanYear, finalLoanDesc, loanStartDate,  loanStartDate, 
            0, perYearCollegeAmt);
        collegeLoanTable.push(newLoanObj);
        newLoanTable.push(newLoanObj);
    }
    const returnObj = {loanTable: newLoanTable, pctOfTuition: pctOfTuition, loanDesc: loanDesc,
        collegeLoanTable: collegeLoanTable
    }
    return returnObj;
}
export default createNewLoanTableObject;